<!--
 * @Author: DXG
 * @Date: 2024-04-19 10:54:35
 * @LastEditors: DXG
 * @LastEditTime: 2024-04-19 13:48:21
 * @FilePath: \kdtup-pc-web\src\components\util\usualProblem.vue
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
-->
<template>
    <div class="usual-container">
        <div class="usual-title">
            <div class="lines"></div>
            <span class="content">登录常见问题</span>
            <div class="lines"></div>
        </div>
        <div class="flex-container">
            <div class="usual-item">
                <img class="img-container" src="@/assets/img/ques1.png" alt="" srcset="" />
                <div class="item-desc">
                    在银行、券商或{{ $const.COMPANY }}基金直销柜台购买过{{
                        $const.COMPANY
                    }}基金的产品登录方式选择“基金账号”，初始密码是您基金账号的后8位。
                </div>
            </div>
            <div class="usual-item">
                <img class="img-container" src="@/assets/img/ques2.png" alt="" srcset="" />
                <div class="item-desc">
                    股东账号(上交所或深交所证券账户)或封闭式基金账号的初始密码为其后6位。
                </div>
            </div>
            <div class="usual-item">
                <img class="img-container" src="@/assets/img/ques3.png" alt="" srcset="" />
                <div class="item-desc">
                    已开通网上交易手段的机构客户登录密码即可使用查询密码，也可以使用交易密码。
                </div>
            </div>
            <div class="usual-item">
                <img class="img-container" src="@/assets/img/ques4.png" alt="" srcset="" />
                <div class="item-desc">
                    未开通网上交易手段的机构客户初始登录密码(即查询密码)是您基金账号后8位。
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.usual-container {
    width: 100%;
    height: 355px;
    background-color: #ffffff;
    .flex-container {
        width: 1242px;
        margin: 32px auto;
        display: flex;
        justify-content: space-around; /* 设置水平方向上子元素的分布 */
        gap: 16px;
        .usual-item {
            flex: 1;
            background-color: #f9f9f9;
            border-radius: 4px;
            border: 1px solid #f1f1f1;
            text-align: center;
            padding-bottom: 34px;
            .img-container {
                width: 60px;
                height: 60px;
                margin: 35px auto 24px;
            }
            .item-desc {
                width: calc(100% - 66px);
                // margin-top: 24px;
                margin: 0 auto;
                color: #666;
                font-size: 14px;
            }
        }
    }
}
.usual-title {
    padding-top: 32px;
    font-size: 20px;
    color: #333333;
    width: 1242px;
    display: flex;
    align-items: center;
    position: relative;
    margin: 0 auto;
    .lines {
        height: 1px;
        background-color: #eaeaea;
        /* 设置横线的间距 */
        flex: 1;
    }
    .content {
        white-space: nowrap;
        margin: 0 15px;
    }
}
</style>
